module.exports = __webpack_public_path__ + "static/media/016.19f016a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/016.jpg
// module id = 489
// module chunks = 0